


















import {Component} from "vue-property-decorator";
import BaseItemSearch from "@/core/components/BaseItemSearch";
import {Api} from "@/core/services/MedicaPro/Api";
import {Medicine} from "@/core/services/MedicaPro/models";

@Component
export default class MedicinePicker extends BaseItemSearch {
    public items: Medicine[] = [];

    public created() {
        super.created();
    }

    public get selectValue(): number | number[] {
        return this.value ?? [];
    }

    public set selectValue(value: number | number[]) {
        this.$emit("input", value);
    }

    private lastSearch: string = 'no-value';

    protected loadItem() {
        if(this.search == this.lastSearch || (this.search == this.value && this.value)) {
            return;
        }
        this.lastSearch = this.search;

        this.loading = true;
        const api = Api.medicines().get();
        if(this.search?.length) {
            api.search("name", this.search);
        }
        api
            .orderAsc("name")
            .limit(100)
            .find(items => {
                this.items = items;
                this.loading = false;
            });
    }
}
